<template>
	<div>
		<div class="user-profile mb-primary">
			<div
				class="card position-relative card-with-shadow py-primary border-0"
			>
				<app-overlay-loader v-if="loading" class="h-100" />
				<div v-else class="row align-items-center">
					<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
						<div
							class="media border-right px-5 pr-xl-5 pl-xl-0 align-items-center user-header-media"
						>
							<form
								class="mb-0"
								ref="form"
								data-url="admin/auth/users/profile-picture"
								:class="{ 'loading-opacity': preloader }"
							>
								<div
									class="profile-pic-wrapper position-relative"
								>
									<app-overlay-loader v-if="preloader" />

									<app-input
										v-else
										id="profile_picture"
										class="circle mx-xl-auto"
										:wrapper-class="'circle mx-xl-auto'"
										name="profile_picture"
										type="custom-file-upload"
										v-model="user.profile_picture"
										:alt="parentProfileCardData.name + ' ' + parentProfileCardData.last_name_parents"
										:generate-file-url="false"
										@change="setProfilePicture"
										:label="$t('change')"
									/>
								</div>
							</form>
							<div class="media-body user-info-header">
								<h5>{{ parentProfileCardData.name + ' ' + parentProfileCardData.last_name_parents != null ? parentProfileCardData.last_name_parents : '' }}</h5>
								<p class="text-muted mb-2">{{ parentProfileCardData.email_parents ?? 'No email' }}</p>
								<span
									class="badge badge-pill badge-success user-status"
									>Active</span
								>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
						<div
							class="user-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0"
						>
							<div class="row">
								<div
									class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6"
								>
									<div class="border-right custom">
										<div class="media mb-4 mb-xl-5">
											<div class="align-self-center mr-3">
												<app-icon :name="'phone'" />
											</div>
											<div class="media-body">
												<p class="text-muted mb-0">
													Contact:
												</p>
												<p class="mb-0">
													{{ parentProfileCardData.contact }}
												</p>
											</div>
										</div>
										<div class="media mb-4 mb-xl-0">
											<div class="align-self-center mr-3">
												<app-icon :name="'phone'" />
											</div>
											<div class="media-body">
												<p class="text-muted mb-0">
													Whatsapp:
												</p>
												<p class="mb-0">
													{{ parentProfileCardData.whatsapp }}
												</p>
											</div>
										</div>
									</div>
								</div>
								<div
									class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6"
								>
									<div class="media mb-4 mb-xl-5">
										<div class="align-self-center mr-3">
											<app-icon :name="'calendar'" />
										</div>
										<div class="media-body">
											<p class="text-muted mb-0">
												Created:
											</p>
											<p class="mb-0">
												{{ parentProfileCardData.created_at_formatted }}
											</p>
										</div>
									</div>
									<div class="media mb-0 mb-xl-0">
										<div class="align-self-center mr-3">
											<app-icon :name="'users'" />
										</div>
										<div class="media-body">
											<p class="text-muted mb-0">
												Children:
											</p>
											<a
												href="?tab=Children+Info"
												class="text-capitalize tab-item-link d-flex justify-content-between my-2 my-sm-3 active"
												><span
													><p class="mb-0">1</p></span
												></a
											>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { UserMixin } from "../../../../Views/Auth/Mixins/UserMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { urlGenerator } from "../../../../../Helpers/AxiosHelper";

export default {
	name: "ParentProfileCard",
	mixins: [FormMixin],
	props: {
		parentId: {
			type: String,
		}
	},
	data() {
		return {
			loading: true,
			preloader: false,
			user: { profile_picture: "" },
			parentProfileCardData: {

			},
		};
	},
	mounted: function () {
		this.fetchData();
		this.getData();
	},
	methods: {
		async fetchData() {
			try {
				const parentProfileResponse = await axios.get(
					"/transaction/parent/" + this.parentId
				);

				// assign data to parentProfileCardData
				this.parentProfileCardData = parentProfileResponse.data;
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		beforeSubmit() {
			this.preloader = true;
		},
		getData() {
			// this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		setProfilePicture($event) {
			const fileValue = $event.target.files[0];
			let formData = new FormData();
			formData.append("profile_picture", fileValue);
			this.save(formData);
		},
		afterFinalResponse() {
			this.preloader = false;
		},
		afterSuccess(res) {
			this.$toastr.s(res.data.message);
			window.location = urlGenerator(actions.MY_PROFILE);
		},
	},
};
</script>
<style scoped>
.card {
	box-shadow: 0 10px 12px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
.user-profile .card {
	min-height: 190px;
}
/* Increase font size and padding to make the badge bigger */
.badge-pill {
	font-size: 15px; /* Adjust the font size as needed */
	padding: 10px 20px; /* Adjust the padding as needed */
}
</style>
